//-------------Importar librerias----------------------------
import React, { Component } from "react";
import axios from "axios";
// import { useInView  } from 'react-intersection-observer';
import { Navigate } from "react-router-dom";
import withRouter from "../../routes/withRouter";
import TodoDataService from '../../hooks/services'
import StyleDragArea from "./css/buttonindex";

// -----------Importar Componentes de Terceros---------------------
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

// -----------Importar Componentes Personalizados------------------
import CoberturaSets from "./Cobertura";
import PersonalizaSets from "./Personaliza/PersonalizaSet";
import SetsInformacion from "../../components/SetsInformacion";

// -----------Importar Archivos Estaticos------------------
import './css/main.css'
import './css/sets.css'
import Ataud_1 from '../../assets/Imagenes/Sets/Atud/ataud 1.png'
import Ataud_2 from '../../assets/Imagenes/Sets/Atud/ataud 2.png'
import Ataud_3 from '../../assets/Imagenes/Sets/Atud/ataud 3.png'

import Cafe_1 from '../../assets/Imagenes/Sets/Cafe/cafe 1.png'
import Cafe_2 from '../../assets/Imagenes/Sets/Cafe/cafe 2.png'
import Cafe_3 from '../../assets/Imagenes/Sets/Cafe/cafe 3.png'


// import { Route } from "react-router-dom";


import CatalogoImagenesProductos from '../../utils/CatalogoImagenesProductos';
import CatalogoImagenesProductosExtras from '../../utils/CatalogoImagenesProductosExtras';


// ------------------------Valores Constantes----------------------------
const UrlValidarCupon = TodoDataService.GetHostRestApi() + '/Cupon/'
const UrlToken = TodoDataService.GetHostRestApi() + '/usuario/login/';
const UrlGetPedidoCliente = TodoDataService.GetHostRestApi() + '/PedidoCliente/'
const datalogin = { email: "apicolumba@funeralescolumba.com.mx", password: "pG7-tl3[02835}4P" }
// const datalogin = { email: "apicolumba@funeralescolumba.com.mx", password: "5M#j7^hBRXY#5Y!m" }

const ListSets = [
  {
    "id": "1",
    "nombre": "Velación en Sala",
    "nombre2": "Velación en Sala",
    "precio": "11,000.00",
    "beneficios": ["Traslados", "Ataúd*", "Sala 24 horas", "Trámites"]
  },
  {
    "id": "2",
    "nombre": "Velación en Casa",
    "nombre2": "Velación en Casa",
    "precio": "10,500.00",
    "beneficios": ["Traslados", "Ataúd*", "Equipo de velación", "Trámites"]
  }, {
    "id": "3",
    "nombre": "Servicio Directo",
    "nombre2": "Servicio Directo",
    "precio": "9,000.00",
    "beneficios": ["Traslados", "Ataúd*", "Trámites"]
  }]

const ListCombos = { 11: 1, 12: 2, 21: 3, 22: 4, 31: 5, 32: 6 }
const ListTypoAtencion = { 1: 'SE', 2: 'A', 3: 'D', 4: 'A', 5: 'D', 6: 'C' }

const ListImagenes = [Ataud_1, Ataud_2, Ataud_3]
const ListImagenesExtra = [Cafe_1, Cafe_2, Cafe_3]



class SetsFunerarios extends Component {
  intervalId = null;

  state = {
    TypoAtencion: '',
    DetalleSetsFuenerarios: false,
    DataDetalleDetalleSetsFuenerarios: { Estado: { nombre: '' }, Municipio: { nombre: '' }, Colonia: { nombre: '' } },
    Route: null,
    TotalServicioDespedida: 0,
    StepLenght: 0,
    Switch: '',
    Token: '',
    ShowAgregarCarrito: false,
    ShowAgregarCarritoExtra: false,
    ProductoSelecionado: '',
    ProductoSelecionadoExtra: '',
    DataSets: [],
    DataEstado: [],
    DataMunicipio: [],
    DataColonia: [],
    ListProductos: [],
    ListGrupos: [],
    ListCarrito: [],
    ListCarritoIncluido: [],
    ListProductosExtra: [],
    ListGruposExtra: [],
    ListCarritoExtra: [],
    Total: '',
    SubTotal: 0,
    SubTotalIncluido: 0,
    SubTotalExtra: 0,
    Descuento: 0,
    Cobertura: false,
    PerzonalizaSets: false,
    ModalConsultarCodigoPostal: false,
    SetSelecionado: '',
    formCobertura: {
      Estado: '',
      Municipio: '',
      Colonia: '',
      CodigoPostal: ''
    },
    form: {
      TipoVelacion: '',
      TipoDespedida: '',
    },
    FormFinado: {
      NombreFinado: '',
      ApellidoPaternoFinado: '',
      ApellidoMaternoFinado: '',
      Gernero: '',
      FechaNacimiento: '',
      Conmemoracion: false,
      NombreLugar: '',
      Direccion: '',
      CodigoPostal: '',
      Estado: '',
      Municipio: '',
      Colonia: '',
      Referencias: '',
      UsoInformacion: false,
      Terminos: false
    },
    FormResponsable: {
      Nombre: '',
      ApellidoPaterno: '',
      ApellidoMaterno: '',
      TelefonoPrimario: '',
      TelefonoSecundario: '',
      Email: '',
      EmailConfirmar: ''
    },
    FormPago: {
      KeyCliente: '',
      Tipo: '',
      TipoContacto: '',
      FolioCupon: '',
      CuponValido: false,
      Error: [],
      PedidoCliente: '',
      Descuento: 0,
      DataTransaccion: '',
      DataValidacionTransaccion: ''
    },
    ListHeadersStep: [
      { id: 0, Label: 'Personaliza tu set', Title: 'Personaliza tu set funerario', Complect: false },
      { id: 1, Label: 'Extra', Title: 'Personaliza tus extras', Complect: false },
      { id: 2, Label: 'Datos de contacto', Title: 'Datos de contacto', Complect: false },
      { id: 3, Label: 'Pago', Title: 'Pago', Complect: false },
      { id: 4, Label: 'Confirmación', Title: 'Confirmación', Complect: false }]
  }


  SeleccionarSet = (item) => {
    this.setState({ SetSelecionado: item, Cobertura: true, Route: '/SetsFunerarios/Cobertura/' + item })
  }

  CompletarStepAll = () => {
    let NewListHeadersStep = this.state.ListHeadersStep.map(element => ({
      ...element,
      Complect: true
    }));
    this.setState({ ListHeadersStep: NewListHeadersStep });
  }

  CompletarStep = () => {
    let NewListHeadersStep = this.state.ListHeadersStep.slice();
    NewListHeadersStep[this.state.StepLenght].Complect = true;
    this.setState({ ListHeadersStep: NewListHeadersStep });

  }


  ShowModalConsultarCodigoPostal = () => {
    this.setState({
      ModalConsultarCodigoPostal: !this.state.ModalConsultarCodigoPostal,
      DataMunicipio: [],
      DataColonia: [], formCobertura: { Estado: '1', Municipio: '', Colonia: '', CodigoPostal: this.state.formCobertura.CodigoPostal }
    })
  }


  OnClickShowAgregarCarrito = (producto) => {
    this.setState({ ShowAgregarCarrito: !this.state.ShowAgregarCarrito, ProductoSelecionado: producto });
  }

  OnClickShowAgregarCarritoExtra = (producto) => {
    this.setState({ ShowAgregarCarritoExtra: !this.state.ShowAgregarCarritoExtra, ProductoSelecionadoExtra: producto });
  }


  ActualizarGrupo = (producto, key) => {
    let listgrupo = this.state[key].map((item) => {
      if (item.grupo === producto.grupo.trim()) {
        item.select = true
      }
      return item
    }
    )
    return listgrupo;
  }


  PeticionProductosGet = async (Url) => {
    axios.defaults.headers.common["Authorization"] = this.state.Token;
    await axios.request(Url).then(async (response) => {  // Hacer la función asincrónica
      let productos = [];
      let grupos = [];
      let list = { carrito: [], incluidos: [] };
      let Total = 0;
      let TotalIncluidos = 0;


      // Usar `for...of` para que puedas usar `await` dentro del bucle
      for (let element of response.data) {

        let imagenes = [];
        let imageneCaratula = [];
        // Usar `await` para esperar que se resuelvan las imágenes
        if (element.grupo_Nombre !== "INCLUIDOS") {
          imagenes = CatalogoImagenesProductos[element.producto.trim()] ?? [];
          imageneCaratula = CatalogoImagenesProductosExtras[element.producto.trim()] ?? [];
        }

        productos.push({
          producto: element.producto.trim(),
          grupo: element.grupo.trim(),
          // nombre_grupo: element.grupo_Nombre.trim().charAt(0).toUpperCase() + element.grupo_Nombre.trim().slice(1).toLowerCase(),
          nombre_grupo: element.grupo_Nombre.trim().toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
          nombre: element.nombre.trim().toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
          nombre_modal: element.nombre.trim().charAt(0).toUpperCase() + element.nombre.trim().slice(1).toLowerCase(),
          precio_venta: element.precio_venta,
          precio: element.precio_venta_sin_iva,
          combo: element.combo,
          valor_default: element.valor_default,
          img_caratula: imageneCaratula.length > 0 ? imageneCaratula : ListImagenes, // Si no hay imágenes, usa ListImagenes
          img: imagenes.length > 0 ? imagenes : ListImagenes // Si no hay imágenes, usa ListImagenes
        });

        // Verificar si el grupo ya está en el listado
        if (!grupos.some((grupo) => grupo.grupo === element.grupo)) {
          grupos.push({
            grupo: element.grupo.trim(),
            nombre_grupo: element.grupo_Nombre.trim().toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
            select: false
          });
        }
      }

      // Filtrar los grupos
      grupos = grupos.filter(grupo => grupo.nombre_grupo !== "Incluidos");
      productos = [...productos].sort((a, b) => a.precio_venta - b.precio_venta);

      // Mapear los productos y asignar los totales
      productos.forEach((element) => {
        if (element.nombre_grupo === "Incluidos") {
          TotalIncluidos += element.precio_venta;
          list.incluidos.push({
            producto: element.producto.trim(),
            nombre_prodcto: element.nombre.trim().charAt(0).toUpperCase() + element.nombre.trim().slice(1).toLowerCase(),
            precio_venta: element.precio_venta,
            cantidad: 1,
            combo: element.combo.trim(),
            grupo: element.grupo.trim(),
            notas: "",
          });
        } else if (element.valor_default === 1) {
          Total += element.precio_venta;
          list.carrito.push({
            producto: element.producto.trim(),
            nombre_prodcto: element.nombre.trim().toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
            precio_venta: element.precio_venta,
            cantidad: 1,
            combo: element.combo.trim(),
            grupo: element.grupo.trim(),
            notas: "",
          });
        }
      });

      list.carrito = [...list.carrito].sort((a, b) => a.grupo - b.grupo);
      // Actualizar el estado
      this.setState({
        ListProductos: productos,
        ListGrupos: grupos,
        ListCarrito: list.carrito,
        ListCarritoIncluido: list.incluidos,
        SubTotal: Total + TotalIncluidos,
        SubTotalIncluido: TotalIncluidos,
        TotalServicioDespedida: Total + TotalIncluidos
      });
    }).catch(error => {
      console.log(error);
    });
  }

  PeticionProductosExtrasGet = async () => {
    axios.defaults.headers.common["Authorization"] = this.state.Token;
    try {
      const response = await axios.request(TodoDataService.GetHostRestApi() + '/establecimiento/productos/2');
      console.log(response.data);
      let productosextra = [];
      let gruposextra = [];

      // Usamos un bucle for...of para poder usar `await` dentro
      for (let element of response.data) {
        for (let producto of element.productos) {
          // Usamos `await` para esperar que las imágenes se carguen
          let imagenes = CatalogoImagenesProductos[producto.productoId.trim()] === undefined ?[]:CatalogoImagenesProductos[producto.productoId.trim()] ;
          let imageneCaratula = CatalogoImagenesProductosExtras[producto.productoId.trim()] === undefined ?[]: CatalogoImagenesProductosExtras[producto.productoId.trim()];

          productosextra.push({
            producto: producto.productoId.trim(),
            nombre: producto.nombre.trim().toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
            nombre_modal: producto.nombre.trim().charAt(0).toUpperCase() + producto.nombre.trim().slice(1).toLowerCase(),
            precio_venta: producto.precioVenta,
            grupo: element.familiaId.trim(),
            nombre_grupo: element.nombre.trim().toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
            img_caratula: imageneCaratula.length > 0 ? imageneCaratula : ListImagenes, // Si no hay imágenes, usa ListImagenes
            img: imagenes.length > 0 ? imagenes : ListImagenesExtra // Si no hay imágenes, usamos un valor predeterminado
          });

          if (!gruposextra.some((grupo) => grupo.grupo === element.familiaId.trim())) {
            gruposextra.push({
              grupo: element.familiaId.trim(),
              nombre_grupo: element.nombre.trim().toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
              select: false
            });
          }
        }
      }

      this.setState({
        ListProductosExtra: productosextra,
        ListGruposExtra: gruposextra
      });
    } catch (error) {
      console.log(error.message);
    }

    this.handleNext('StepLenght');
  }



  AgregarCarrito = (producto) => {
    let listcarrito = []
    const buscarGrupoProductos = this.state.ListCarrito.find((item) => item.grupo === producto.grupo);
    if (buscarGrupoProductos !== undefined)
      listcarrito = this.state.ListCarrito.filter(
        (item) => item.grupo !== buscarGrupoProductos.grupo
      );

    listcarrito.push({
      producto: producto.producto.trim(),
      nombre_prodcto: producto.nombre.trim(),
      precio_venta: producto.precio_venta,
      cantidad: 1,
      combo: producto.combo.trim(),
      grupo: producto.grupo.trim(),
      notas: "",
    });


    let total = 0
    listcarrito.forEach((element) => { total += element.precio_venta })
    listcarrito = [...listcarrito].sort((a, b) => a.grupo - b.grupo);


    let listgrupos = this.ActualizarGrupo(producto, 'ListGrupos');
    this.setState({ ListCarrito: listcarrito, SubTotal: total + this.state.SubTotalIncluido, ListGrupos: listgrupos })
    this.OnClickShowAgregarCarrito('');
  };

  AgregarCarritoExtra = (producto, cantidadP) => {
    let listcarritoextra = []
    listcarritoextra = this.state.ListCarritoExtra.filter(
      (item) => item.producto !== producto.producto
    );

    listcarritoextra.push({
      producto: producto.producto.trim(),
      nombre_prodcto: producto.nombre.trim(),
      precio_venta: producto.precio_venta,
      cantidad: parseInt(cantidadP),
      combo: this.state.ListCarrito[0].combo,
      grupo: producto.grupo.trim(),
      notas: "",
    });

    let total = 0
    listcarritoextra.forEach((element) => { total += (element.precio_venta * element.cantidad) })

    let listgruposextra = this.ActualizarGrupo(producto, 'ListGruposExtra');
    this.setState({ ListCarritoExtra: listcarritoextra, SubTotalExtra: total, ListGruposExtra: listgruposextra })
    this.OnClickShowAgregarCarritoExtra('');
  };


  EliminarCarrito = (producto) => {
    let listcarrito = []
    const productodefault = this.state.ListProductos.find(element => element.grupo === producto.grupo && element.valor_default === 1);

    listcarrito = this.state.ListCarrito.filter(
      (item) => item.producto !== producto.producto
    );

    listcarrito.push({
      producto: productodefault.producto.trim(),
      nombre_prodcto: productodefault.nombre.trim(),
      precio_venta: productodefault.precio_venta,
      cantidad: 1,
      combo: productodefault.combo.trim(),
      grupo: productodefault.grupo.trim(),
      notas: "",
    });

    let total = 0
    listcarrito.forEach((element) => { total += element.precio_venta })

    this.setState({ ListCarrito: listcarrito, SubTotal: total + this.state.SubTotalIncluido })
  };

  EliminarCarritoExtra = (producto) => {
    let listcarritoextra = []

    listcarritoextra = this.state.ListCarritoExtra.filter(
      (item) => item.producto !== producto.producto
    );
    let total = 0
    listcarritoextra.forEach((element) => { total += (element.precio_venta * element.cantidad) })

    this.setState({ ListCarritoExtra: listcarritoextra, SubTotalExtra: total })
  };

  SwitchHandleChange = (item) => {
    this.setState({ Switch: item })
  }

  ShowCobertura = () => {
    this.setState({ Cobertura: !this.state.Cobertura })
  }

  handleChange = async (e) => {
    await this.setState({
      [this.state.Switch]: {
        ...this.state[this.state.Switch],
        [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
      }
    });
  }

  handleChangeSingle = (Key, Name, Item) => {
    this.setState({
      [Key]: {
        ...this.state[Key],
        [Name]: Item
      }
    });
  }


  PeticionGet = async (Url, SetData) => {
    axios.defaults.headers.common["Authorization"] = this.state.Token;
    await axios.request(Url).then(response => {
      this.setState({ [SetData]: response.data })
    }).catch(error => {
      console.log(error);
    })
  };

  PeticionGetHome = async (Url, SetData) => {
    axios.defaults.headers.common["Authorization"] = await this.GetPeticionToken();
    await axios.request(Url).then(response => {
      this.setState({ [SetData]: response.data })
    }).catch(error => {
      console.log(error);
    })
  };


  HandleChangeCobertura = async (e) => {

    await this.handleChange(e);
    if (e.target.name === 'Estado') {
      this.setState({ formCobertura: { ...this.state.formCobertura, Municipio: '', Colonia: '', CidigoPostal: '' } });
      await this.PeticionGet(TodoDataService.GetHostRestApi() + '/Municipios/' + this.state.formCobertura.Estado, 'DataMunicipio');
    }
    if (e.target.name === 'Municipio') {
      this.setState({ formCobertura: { ...this.state.formCobertura, Colonia: '', CidigoPostal: '' } });
      await this.PeticionGet(TodoDataService.GetHostRestApi() + '/Asentamientos/municipio/' + this.state.formCobertura.Municipio, 'DataColonia');
    }
    if (e.target.name === 'Colonia') {
      this.setState({ formCobertura: { ...this.state.formCobertura, CodigoPostal: this.state.DataColonia.find((element) => (element.asentamientoId.trim() === this.state.formCobertura.Colonia)).cp } });
    }
  }


  HandleChangeCoberturaFinado = async (e) => {

    await this.handleChange(e);
    if (e.target.name === 'Estado') {
      this.setState({ FormFinado: { ...this.state.FormFinado, Municipio: '', Colonia: '', CidigoPostal: '' } });
      await this.PeticionGet(TodoDataService.GetHostRestApi() + '/Municipios/' + this.state.FormFinado.Estado, 'DataMunicipio');
    }
    if (e.target.name === 'Municipio') {
      this.setState({ FormFinado: { ...this.state.FormFinado, Colonia: '', CidigoPostal: '' } });
      await this.PeticionGet(TodoDataService.GetHostRestApi() + '/Asentamientos/municipio/' + this.state.FormFinado.Municipio, 'DataColonia');
    }
    if (e.target.name === 'Colonia') {
      this.setState({ FormFinado: { ...this.state.FormFinado, CodigoPostal: this.state.DataColonia.find((element) => (element.asentamientoId.trim() === this.state.FormFinado.Colonia)).cp } });
    }
  }

  SeleccionarDespedida = (Item) => {
    this.handleChangeSingle('form', 'TipoDespedida', Item)
    let Combo = ListCombos[this.state.SetSelecionado.concat(Item)]
    let atencion = ListTypoAtencion[Combo]
    this.setState({ TypoAtencion: atencion });
    this.PeticionProductosGet(TodoDataService.GetHostRestApi() + `/Sets/productos/2/${Combo}/0021`);
  }

  ShowPersonalizaSets = () => {
    this.setState({ PerzonalizaSets: !this.state.PerzonalizaSets, Route: null })
  }

  GetPeticionToken = async () => {
    let result = '';
    await axios.post(UrlToken, datalogin).then(response => {
      this.setState({ Token: 'Bearer ' + response.data.token })
      result = 'Bearer ' + response.data.token
    }).catch(error => {
      console.log(error);
    });
    return result
  }

  ClosePersonalizarSet = () => {
    this.setState({
      PerzonalizaSets: false, ListCarrito: [], ListProductos: [], ListGrupos: [], ModalConsultarCodigoPostal: false, ProductoSelecionado: '', StepLenght: 0, SubTotal: 0, ShowAgregarCarrito: false, formCobertura: {
        Estado: '',
        Municipio: '',
        Colonia: '',
        CodigoPostal: ''
      }
    })
  }


  handleNext = (key) => {
    this.CompletarStep();
    this.setState({ [key]: this.state[key] + 1 });
  };

  handleBack = (key) => {
    this.setState({ [key]: this.state[key] - 1 });
  };

  PeticionGetPedidoCliente = async (id) => {
    try {
      axios.defaults.headers.common["Authorization"] = await this.GetPeticionToken();
      const response = await axios.request(UrlGetPedidoCliente + id);
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  async componentDidMount() {
    this.scrollToTop();
    if (this.props.params.id) {
      let appState = JSON.parse(localStorage.getItem('appState'));

      if (appState) {
        appState.StepLenght = 4;
        appState.DataDetalleDetalleSetsFuenerarios.Estado.nombre = appState.DataEstado.find(estado => estado.estadoId.trim() === appState.FormFinado.Estado).nombre
        appState.DataDetalleDetalleSetsFuenerarios.Municipio.nombre = appState.DataMunicipio.find(municipio => municipio.municipioId.trim() === appState.FormFinado.Municipio).nombre
        appState.DataDetalleDetalleSetsFuenerarios.Colonia.nombre = appState.DataColonia.find(colonia => colonia.asentamientoId.trim() === appState.FormFinado.Colonia).nombre

        appState.DetalleSetsFuenerarios = true;


        this.setState(appState);
        this.CompletarStepAll();
      }
    }

    if (this.props.params.idcobertura) {
      this.PeticionGetHome(TodoDataService.GetHostRestApi() + "/Estados/1", 'DataEstado');
      this.SeleccionarSet(this.props.params.idcobertura);
    }
    else {
      this.GetPeticionToken();
    }
    this.GetPeticionToken();

    this.intervalId = setInterval(async () => {
      await this.GetPeticionToken();
    }, 4 * 60 * 1000);
  }

  componentWillUnmount() {
    // Limpia el intervalo cuando el componente se desmonta
    clearInterval(this.intervalId);
  }

  OnClickBarraProgreso = (item) => {
    this.setState({ StepLenght: item });
  }

  setData = (data) => {
    this.setState(
      data
    );
  }


  // Función para enviar un mensaje con el estado actual
  EnviarMensaje = () => {
    localStorage.setItem('appState', JSON.stringify(this.state));
  };



  render() {
    let { Route } = this.state;
    console.log(this.state);
    const settings = {
      autoplay: true,
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      arrows: false,
    };
    return (
      <Box className='hola'>
        <Container sx={{ marginTop:this.state.Cobertura?'0px': { xs: '40px', sm: '105px' }, padding: '0px 16px !important', maxWidth: '1170px !important' }}>
          {Route && (
            <Navigate to={Route} replace={true} />
          )}
          {

            this.state.Cobertura === false
              ?
              this.props.params.id
                ?
                <></>
                :
                <section>
                  <div>
                    <div className="row">
                      <div className="col-md-12 ">
                        <div className="row">
                          <div className="col-xs-8 col-sm-6 ">
                            <Typography mb='20px' variant="h1" sx={{ color: '#d14081', fontSize: '32px' }} className="tituloprincipal">Selecciona tu set funerario</Typography>
                          </div>
                          <div style={{ position: 'relative' }} className="col-xs-4 col-sm-6">
                            <span className="breadcrum">
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <Typography mb={{xs:'40px',sm:'50px'}} sx={{ fontSize: '18px', color: 'black' }} className="subtituloprincipal">
                              Aquí podrás elegir el servicio funerario inmediato que más se adapte a tus necesidades.
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </div>
                    <StyleDragArea>
                      <div className="row  justify-content-between mr-1   PLate-0" style={{ margin: '0px' }}>
                        {
                          ListSets.map((Set) => (
                            <div onClick={() => { this.PeticionGet(TodoDataService.GetHostRestApi() + "/Estados/1", 'DataEstado'); this.SeleccionarSet(Set.id) }} style={{ cursor: 'pointer', width: 'auto' }} key={'per' + Set.id} className="col-sm-4  containerset seccion3 ">
                              <div className=".set card containerset" style={{ width: '20rem' }}>
                                <div className="card-header pt-3 pb-3">
                                  <h4 className="card-title set">{Set.nombre} desde</h4>
                                  <h4 className="subset">$ {Set.precio} MX</h4>
                                </div>
                                <div className="card-body mt-3">
                                  <h6 className="beneficios">Beneficios</h6>
                                  {Set.beneficios.map((beneficio, index) => (<p key={index + 'per' + Set.id} className="listbeneficios">{beneficio}</p>))
                                  }
                                </div>
                                <div className="card-footer mb-2">
                                  <button style={{ width: '200px', fontSize: '18px',padding:'7.3px 12px' }} onClick={() => { this.PeticionGet(TodoDataService.GetHostRestApi() + "/Estados/1", 'DataEstado'); this.SeleccionarSet(Set.id) }} type="button" className="btn btn_rosa mt-2"  >Contratar ahora</button>
                                </div>
                              </div>
                            </div>
                          ))
                        }
                      </div >

                    </StyleDragArea>
                  </div >

                </section >
              :
              this.state.PerzonalizaSets === false
                ?
                <CoberturaSets CallNumber={TodoDataService.GetNumberCall()} OnClickClose={() => (this.setState({ Route: '/' }))} SwitchHandleChange={this.SwitchHandleChange} OnClickPersonaliza={this.ShowPersonalizaSets} DataEstado={this.state.DataEstado} HandleChange={this.handleChange} DataMunicipio={this.state.DataMunicipio} DataColonia={this.state.DataColonia} Token={this.state.Token} OnChange={this.HandleChangeCobertura} FormCobertura={this.state.formCobertura} ModalConsultarCodigopostal={this.state.ModalConsultarCodigoPostal} ShowModalConsultarCodigoPostal={this.ShowModalConsultarCodigoPostal} />
                :
                < PersonalizaSets CallNumber={TodoDataService.GetNumberCall()} ActualizarMarginFoother={this.props.ActualizarMarginFoother} OnClickBarraProgreso={this.OnClickBarraProgreso}
                  Step_Datos={{ FormCobertura: this.state.formCobertura, OnClickGenerarCliente: TodoDataService.PostGenerarCliente, OnChangeCobertura: this.HandleChangeCoberturaFinado, OnChange: this.handleChange, ListEstados: this.state.DataEstado, ListMunicipios: this.state.DataMunicipio, ListColonias: this.state.DataColonia, FormFinado: this.state.FormFinado, FormResponsable: this.state.FormResponsable, }}
                  Step_PersonalizaSet={{ EliminarCarrito: this.EliminarCarrito, ProductoSelecionado: this.state.ProductoSelecionado, OnClickShowAgregarCarrito: this.OnClickShowAgregarCarrito, ShowAgregarCarrito: this.state.ShowAgregarCarrito, OnClickAgregarCarrito: this.AgregarCarrito, ListProductos: this.state.ListProductos, ListGrupos: this.state.ListGrupos, ListCarrito: this.state.ListCarrito, SeleccionarDespedida: this.SeleccionarDespedida, ListCarritoIncluido: this.state.ListCarritoIncluido }}
                  Step_Extra={{ EliminarCarritoExtra: this.EliminarCarritoExtra, AgregarCarritoExtra: this.AgregarCarritoExtra, ShowAgregarCarritoExtra: this.state.ShowAgregarCarritoExtra, ProductoSelecionadoExtra: this.state.ProductoSelecionadoExtra, OnClickShowAgregarCarritoExtra: this.OnClickShowAgregarCarritoExtra, CargarProductosExtras: this.PeticionProductosExtrasGet, ListProductosExtras: this.state.ListProductosExtra, ListGruposExtras: this.state.ListGruposExtra, ListCarritoExtras: this.state.ListCarritoExtra }}
                  Step_Pago={{ TypoAtencion: this.state.TypoAtencion, SetSeleccionado: this.state.SetSelecionado, FormFinado: this.state.FormFinado, FormResponsable: this.state.FormResponsable, OnClickGuardar: TodoDataService.PostNuevoservicio, DataValidarCupon: { Url: UrlValidarCupon, Token: this.state.Token, Data: this.state.FormPago, SetError: this.setData }, OnClickValidarCupon: TodoDataService.ValidarCupon, FormPago: this.state.FormPago, OnChange: this.handleChange, HandleChangeSingle: this.handleChangeSingle }}
                  Step_Confirmacion={{ UrlHost: TodoDataService.GetHost(), EnviarEmailComprovante: TodoDataService.PostEmailComprovante }}
                  TotalServicioDespedida={this.state.TotalServicioDespedida} HandleNext={this.handleNext} HandleBack={this.handleBack} StepLenght={this.state.StepLenght} ListHeadersStep={this.state.ListHeadersStep} Token={this.state.Token} OnclickReturn={() => { this.ClosePersonalizarSet(); this.props.OcultarFoother(); }} SubTotal={this.state.SubTotal} SubTotalExtra={this.state.SubTotalExtra} SwitchHandleChange={this.SwitchHandleChange} DataSets={ListSets} SetSeleccionado={this.state.SetSelecionado} FormActualizar={this.state.form} OcultarFoother={this.props.OcultarFoother}
                  DetalleSetsFuenerarios={this.state.DetalleSetsFuenerarios} DataDetalleSetsFuenerarios={this.state.DataDetalleDetalleSetsFuenerarios} EnviarMensaje={this.EnviarMensaje} />
          }
        </Container>
        {
          this.state.Cobertura === false
            ?
            this.props.params.id
              ?
              <></>
              :
              <Box bgcolor={{xs:'#FFFCEC',sm:'#ffffff'}}>
                <Box pb={{ xs: '45px', sm: '120px' }}>
                  <SetsInformacion />
                </Box>
              </Box>



            :
            <></>
        }
      </Box>



    );
  }
}


// Se exporta el componente con withRouter para acceder a las props de enrutamiento
export default withRouter(SetsFunerarios);



